import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/apiClient";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin", { replace: true }); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm bg-card border border-white/10 rounded-lg p-8">
        <p className="text-overline mb-2">Panel de administración</p>
        <h1 className="font-display text-3xl mb-8">Valientes Cenizas</h1>
        <div className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">Correo</Label>
            <Input id="email" type="email" data-testid="login-email-input" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-secondary border-border" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" type="password" data-testid="login-password-input" value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-secondary border-border" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-destructive">{error}</p>}
          <Button type="submit" data-testid="login-submit-button" disabled={loading} className="w-full h-11 bg-primary text-primary-foreground hover:bg-white/90 uppercase tracking-wide">
            {loading ? "Ingresando…" : "Ingresar"}
          </Button>
        </div>
        <a href="/" className="block text-center text-xs text-muted-foreground mt-6 hover:text-foreground">← Volver a la tienda</a>
      </form>
    </div>
  );
}
